import React from "react";
// import styles from "./Home.module.scss";

const Home = () => {
  return <div>Home</div>;
};

export default Home;
